var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSkillwillLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 232.146,
    height: 30,
    viewBox: "0 0 232.146 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Untitled-2",
    transform: "translate(0 -47.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62379",
    "data-name": "Group 62379",
    transform: "translate(0 47.93)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30777",
    "data-name": "Path 30777",
    d: "M0,54.644H6.714v6.714h6.714V47.93H0Z",
    transform: "translate(0 -47.93)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62385",
    "data-name": "Group 62385",
    transform: "translate(26.118 47.93)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_62380",
    "data-name": "Group 62380",
    transform: "translate(114.323 0.022)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30778",
    "data-name": "Path 30778",
    d: "M1267.53,48.45V68.058l5.747,5.166V48.45Z",
    transform: "translate(-1254.715 -48.409)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30779",
    "data-name": "Path 30779",
    d: "M1187.4,48.11V72.924h-20.11V48.151h-5.746v23.97l6.591,5.926,25.027.041V48.111H1187.4Z",
    transform: "translate(-1161.54 -48.11)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_30780",
    "data-name": "Path 30780",
    d: "M673.151,78.087H667.39V48.11h5.761Z",
    transform: "translate(-612.814 -48.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30781",
    "data-name": "Path 30781",
    d: "M1466.391,77.906h-5.761V47.93h5.761Z",
    transform: "translate(-1310.144 -47.93)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_62381",
    "data-name": "Group 62381",
    transform: "translate(64.861 0.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30782",
    "data-name": "Path 30782",
    d: "M772.977,73.554H758.2V48.78H752.45V72.75l6.591,5.926h13.936Z",
    transform: "translate(-752.45 -48.78)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62382",
    "data-name": "Group 62382",
    transform: "translate(89.591 0.103)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30783",
    "data-name": "Path 30783",
    d: "M977.517,73.554H962.736V48.78H956.99V72.75l6.591,5.926h13.936Z",
    transform: "translate(-956.99 -48.78)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62383",
    "data-name": "Group 62383",
    transform: "translate(160.771 0.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30784",
    "data-name": "Path 30784",
    d: "M1566.217,73.374h-14.781V48.6h-5.746V72.57l6.591,5.926h13.936Z",
    transform: "translate(-1545.69 -48.6)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_62384",
    "data-name": "Group 62384",
    transform: "translate(185.501 0.081)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_30785",
    "data-name": "Path 30785",
    d: "M1770.757,73.374h-14.781V48.6h-5.745V72.57l6.591,5.926h13.936Z",
    transform: "translate(-1750.23 -48.6)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_30786",
    "data-name": "Path 30786",
    d: "M236.594,53.825V48.94H222.562q-3.275,2.945-6.552,5.889V66.37h15.177v7.311H216.011v5.135h13.966l6.616-5.948V61.235H221.417V53.825Z",
    transform: "translate(-216.01 -48.818)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30787",
    "data-name": "Path 30787",
    d: "M590.427,48.11H585.02V60.523l5.4-6.016Q590.427,51.309,590.427,48.11Z",
    transform: "translate(-540.403 -48.088)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30788",
    "data-name": "Path 30788",
    d: "M468.38,155.886h14.1V168.3h5.407q0-6.357,0-12.712l-5.4-4.852-9.47,0Z",
    transform: "translate(-437.866 -138.301)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_30789",
    "data-name": "Path 30789",
    d: "M429.067,65.673V48.11H423.66V78.087h5.407V65.673Z",
    transform: "translate(-398.553 -48.088)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkillwillLogo);
export default __webpack_public_path__ + "static/media/skillwill-logo.eb6339aacc91f17f7b4d36f55e971251.svg";
export { ForwardRef as ReactComponent };